import https from "./https";
import store from "@/store";

const organization = store.state.liffGeneral.orgCode;

const staffActive = {
  async getInfo() {
    let response = await https.get(`${organization}/liff/staff/info`);
    return response.data.data;
  },

  verifyPhone(payload) {
    return https.post(`${organization}/liff/staff/phone/verify`, payload);
  },

  sendPhone(payload) {
    return https.post(`${organization}/liff/staff/phone/send`, payload);
  },

  resendPhone(payload) {
    return https.post(`${organization}/liff/staff/phone/resend`, payload);
  },

  async validateActive(payload) {
    return https.post(`${organization}/liff/staff_validate_active`, payload);
  },

  async staffActive(payload) {
    return https.post(`${organization}/liff/staff_active`, payload);
  },
};

export default staffActive;
